<template>
  <div class="home-module">
    <!-- 限时抢购 -->
    <!-- <special-offers
      v-if="limitPurchaseProductList.indexGoodProductVOList"
      :list="limitPurchaseProductList.indexGoodProductVOList"
    >
    </special-offers> -->

    <!-- 自营优品 -->
    <goodsList
      v-if="selfRunGoodsList.length > 0"
      :list="selfRunGoodsList"
      title="自营优品"
      subTitle="品牌好货放心买"
      :isShowBg="true"
      url="/self-owned-mall"
    >
    </goodsList>

     <!-- 每日新品 -->
     <goodsList
      v-if="newDailyGoodsList.length > 0"
      :list="newDailyGoodsList"
      title="每日新品"
      subTitle="好货常换  惊喜不断"
      :isShowBg="false"
      :url="'/recommend-goods?type=6'"
    >
    </goodsList>
  </div>
</template>

<script>
import goodsList from "./goodsList";

export default {
  components: {
    goodsList,
  },
  props: ["newDailyGoodsList", "selfRunGoodsList", "enterpriseShopGoodsList"],
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
.ads {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// index.vue?6a1f01c6